import { render, staticRenderFns } from "./ArticleVariantsList.vue?vue&type=template&id=a3381c2e"
import script from "./ArticleVariantsList.vue?vue&type=script&lang=js"
export * from "./ArticleVariantsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports